var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgParaguay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9996 40C31.0453 40 39.9996 31.0457 39.9996 20C39.9996 8.95435 31.0453 4.95911e-05 19.9996 4.95911e-05C8.95394 4.95911e-05 -0.000366211 8.95435 -0.000366211 20C-0.000366211 31.0457 8.95394 40 19.9996 40Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 1.90735e-05C12.0708 1.90735e-05 5.21956 4.61447 1.98456 11.3044H38.0154C34.7805 4.61447 27.9292 1.90735e-05 20 1.90735e-05V1.90735e-05Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 40C27.9292 40 34.7805 35.3856 38.0155 28.6956H1.98456C5.21956 35.3856 12.0708 40 20 40Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.919 14.2115L23.0744 16.0561C23.8612 16.8429 24.3479 17.9299 24.3479 19.1305C24.3479 21.5318 22.4012 23.4783 20.0001 23.4783C17.5989 23.4783 15.6523 21.5317 15.6523 19.1305C15.6523 17.9299 16.139 16.8429 16.9258 16.0561L15.0812 14.2115C13.8222 15.4703 13.0436 17.2094 13.0436 19.1305C13.0436 22.9725 16.1581 26.087 20.0001 26.087C23.842 26.087 26.9565 22.9725 26.9565 19.1305C26.9565 17.2094 26.1779 15.4703 24.919 14.2115V14.2115Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 16.5217L20.6476 18.5147H22.743L21.0477 19.7462L21.6953 21.7391L20 20.5075L18.3047 21.7391L18.9523 19.7462L17.257 18.5147H19.3524L20 16.5217Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_923"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParaguay);
export default __webpack_public_path__ + "static/media/paraguay.79c27e217a1f3b420941b3d190b323e5.svg";
export { ForwardRef as ReactComponent };